$(function(){
    $('.js-form_number_input_con').append("<div aria-label='" + aria_label_menge_minus + "' role='button' tabindex='0' class=\"form_number-button form_number-down\">-</div>");
    $('.js-form_number_input_con').append("<div aria-label='" + aria_label_menge_plus + "' role='button' tabindex='0' class=\"form_number-button form_number-up\">+</div>");
    $('.js-form_number_input_con').each(function(){
        var spinner = $(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.form_number-up'),
            btnDown = spinner.find('.form_number-down'),
            min = input.attr('min'),
            max = parseInt(input.attr('max'));

        if(spinner.find("input").prop("disabled") || spinner.find("input").prop("readonly")){
            spinner.find(".form_number-down").remove();
            spinner.find(".form_number-up").remove();
        }

        btnUp.on('click keydown',function(e){
            if(e.type !== 'click' &&  e.key === " "){
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            if(e.type === 'keydown' && e.key !== "Enter") return;

            if(spinner.find("input").prop("disabled") || spinner.find("input").prop("readonly")) return false;

            var oldValue = parseInt(input.val()) || 0;
            if(max > 0){
                if(oldValue >= max){
                    var newVal = oldValue;
                }else{
                    var newVal = oldValue + 1;
                }
                newVal = Math.min(newVal,max);
            }else{
                var newVal = oldValue + 1;
            }

            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });

        btnDown.on('click keydown',function(e){
            if(e.type !== 'click' &&  e.key === " "){
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            if(e.type === 'keydown' && e.key !== "Enter") return;
            if(spinner.find("input").prop("disabled") || spinner.find("input").prop("readonly")) return false;

            var oldValue = parseFloat(input.val()) || 0;
            if(oldValue <= min){
                var newVal = oldValue;
            }else{
                var newVal = oldValue - 1;
            }
            newVal = Math.max(newVal,1);
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });

    });
});

